import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import MessaggioAction from "./MessaggioAction";
import IMessaggioState from "./models/IMessaggioState";
import NuovoMessaggioFormModel from "./models/NuovoMessaggioFormModel";

export default class MessaggioReducer extends BaseReducer<IMessaggioState> {
    public readonly initialState: IMessaggioState = {
        nuovoMessaggioForm: new NuovoMessaggioFormModel({}),
        inviaBanca: false,
    };

    public [MessaggioAction.REQUEST_SIMULAZIONE_NUOVO_MESSAGGIO_FORM_SET_FINISHED](
        state: IMessaggioState,
        action: IAction<NuovoMessaggioFormModel>
    ): IMessaggioState {
        return {
            ...state,
            nuovoMessaggioForm: action.payload!,
        };
    }

    public [MessaggioAction.REQUEST_SIMULAZIONE_SET_INVIA_A_BANCA](
        state: IMessaggioState,
        action: IAction<boolean>
    ): IMessaggioState {
        return {
            ...state,
            inviaBanca: action.payload!,
        };
    }

    public [MessaggioAction.REQUEST_SIMULAZIONE_RESET_NUOVO_MESSAGGIO](
        state: IMessaggioState,
        action: IAction<any>
    ): IMessaggioState {
        return {
            ...state,
            nuovoMessaggioForm: this.initialState.nuovoMessaggioForm,
        };
    }
}
